import { render, staticRenderFns } from "./moreHTFTETG.vue?vue&type=template&id=db2e4630&lang=pug&"
import script from "./moreHTFTETG.vue?vue&type=script&lang=js&"
export * from "./moreHTFTETG.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports